<template>
    <div>
      <v-navigation-drawer 
        :color="$vuetify.theme.themes['dark'].background"
        v-model="drawer" 
        app
      >
        <!-- 側邊欄上方系統名稱  -->
        <v-list>
          <v-list-item >
            <v-list-item-avatar
              color="white"
              size="56"
              tile
            >
              <v-img src="@/assets/logo.jpeg"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title 
                  class="text-h6 white--text"
              >
                Optimize99
              </v-list-item-title>
              <v-list-item-subtitle
                  class="white--text lighten-4"
              >
                管理員後台
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <!-- 功能列表 -->
        <!-- 功能列表 Start -->
        <v-list
          dense
          nav
          link
        >
          <template v-for="( item, i ) in routes">
            
            <v-list-group 
              v-if="item.is_show_sidebar"
              :key="i" 
              no-action
              color="white"
              eager
              :value="isOpen($route.path, item.feature)"
            >
              <template v-slot:activator>

                  <v-list-item-icon class="mr-4" color="white">
                      <v-icon
                          class="white--text"
                          :class="$route.path.indexOf(item.feature) !== -1 ? 'item-activate-text-background' : ''"
                      >
                          {{ item.icon }}
                      </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title
                      :class="$route.path.indexOf(item.feature) !== -1 ? 'item-activate-text-background' : ''"
                      class="white--text"
                    >
                      {{ item.name }}
                    </v-list-item-title>
                  </v-list-item-content>
              </template>

                <template v-for="(child, i) in item.children">
                  <v-list-item
                    v-if="child.is_show_sidebar"
                    :key="i"
                    @click="$router.push(child.link)"
                    link
                    :class="isActivateFeature($route.path, child)"
                    style="padding: 0px 0px 0px 2.25rem; margin-bottom: 0px;"
                  >
                      <div v-if=" child.feature !== '' " >
                        <v-list-item-content
                          style="padding: 12px 0px 12px 1rem; border-left: 1px solid #fff;"
                        >
                          <v-list-item-title
                            class="white--text"
                            :class="$route.path.indexOf(child.feature) !== -1 ? 'item-activate-text' : ''"
                          >
                            {{ `${child.name}` }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </div>
                      
                  </v-list-item>
                  
                </template>

              <v-icon 
                slot="appendIcon" color="white"
              >
                mdi-chevron-down
              </v-icon>

            </v-list-group>

          </template>


          
        </v-list>
        
      </v-navigation-drawer>

      <v-app-bar app>
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        
        <!-- 有設定麵包屑的話，用麵包屑的樣式 -->
        <template v-if="$route.meta.breadcrumbs !== undefined && $route.meta.breadcrumbs.length !== 0">

            <!-- <template v-if="this.$store.getters.replace_breadcrumbs && this.$store.getters.replace_breadcrumbs.length !== 0">
              <v-breadcrumbs 
                class="pl-0"
                large
                :items="this.$store.getters.replace_breadcrumbs"
              >
                <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                </template>
             </v-breadcrumbs>

            </template> -->

            <template >
              <v-breadcrumbs 
                class="pl-0"
                large
                :items="this.$route.meta.breadcrumbs"
              >
                <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                </template>
             </v-breadcrumbs>

            </template>
        </template>

        <!-- 沒設定麵包屑的話，顯示名字 -->
        <template v-else>
          <v-toolbar-title>

            {{ $route.name }}
          </v-toolbar-title>

        </template>


        <v-spacer></v-spacer>

        <!-- 使用者圖標icon -->
        <v-menu
            bottom
            min-width="200px"
            rounded
            offset-y
        >

            <template v-slot:activator="{ on }">
                <v-avatar
                    :color="$vuetify.theme.themes['dark'].avatar"
                    size="32"
                    class="mr-5"
                    v-on="on"
                    style="cursor: pointer;"
                >
                    <v-icon dark>
                        mdi-account-circle
                    </v-icon>
                </v-avatar>
                
            </template>
            <v-card>
                <v-list-item-content class="justify-center">
                    <div class="mx-auto text-center">

                        <v-avatar
                          :color="$vuetify.theme.themes['dark'].avatar"
                        >
                            <v-icon dark>
                                mdi-account-circle
                            </v-icon>
                        </v-avatar>

                        <h4 class="mt-2">
                            {{login_info.name}}
                        </h4>

                        <v-divider class="my-3"></v-divider>

                        <v-btn
                            depressed
                            rounded
                            text
                            @click="logout"
                        >
                            登出
                        </v-btn>
                    </div>
                </v-list-item-content>
            </v-card>		
        </v-menu>
      </v-app-bar>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import private_routes from '@/routes/private_routes.js'

  export default {
    data () {
      return {
        drawer: true,
        items: [
          { title: 'Home', icon: 'mdi-home-city' },
          { title: 'My Account', icon: 'mdi-account' },
          { title: 'Users', icon: 'mdi-account-group-outline' },
        ],
        mini: true,
        routes: private_routes
      }
    },
    mounted: function(){
    },
    methods: {
      logout: function(){
        localStorage.clear()
        this.$router.push('/login')
      },
      isOpen: function(now_path, feature){
        return now_path.includes(feature)
      },
      isActivateFeature: function(now_path, child){
        console.log('now_path.indexOf(child.feature', now_path.indexOf(child.feature))
        if (now_path.indexOf(child.feature) !== -1) {
          return 'item-activate'
        }
        else {
          return ''
        }
      },
      goPage: function(link){
        console.log(link)
        this.$router.push(link).catch((err)=>{
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        })        
      }
    },
    computed: {
      ...mapGetters(["login_info"])
    }
  }
</script>
<style scoped>
.item-activate {
  background: #FFF;
  
}
.item-activate-text {
  color: #353f4d !important;
}
</style>